export class StripeState {
  constructor(
    public connection: string,
    public profileURL: string,
    public connectURL: string,
    public step: number,
    public data: any
  ) {}
}
